import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import './DiscussionContent.scss';
import {
    linkify,
    truncateWithEllipsis,
    boldify,
} from '../../../utilities/ui_utilities';
import {
    emitEngagement,
    objectTypes,
} from '../../../utilities/getStreamAnalytics';
import { PageContext } from '../../../contexts/ContextCreator';

const DiscussionContent = ({
    title,
    description,
    characterLimit,
    showMoreButton,
    handleLinkClickMetricEmit,
    content,
}) => {
    const { isLoggedIn, wrapAuth } = useContext(PageContext);

    const [expandContent, setExpandContent] = useState(!showMoreButton);
    const {
        pageProps: {
            session: { id, name },
        },
    } = useContext(PageContext);
    const truncatedDescription = truncateWithEllipsis(
        `${description || ''}`,
        characterLimit,
        false
    );
    const trueTitle = linkify(title);
    let trueDescription = linkify(description);
    let trueTruncatedDescription = linkify(truncatedDescription);
    if (title === '' || !title) {
        trueTruncatedDescription = boldify(trueTruncatedDescription);
        trueDescription = boldify(trueDescription);
    }
    const handleExpandClick = () => {
        if (!isLoggedIn()) return;

        setExpandContent(true);
        handleLinkClickMetricEmit('more-content-click');
        emitEngagement(
            { id, name },
            {
                label: 'seeMoreOfContent',
                score: 1,
                content: {
                    foreign_id: `${objectTypes()[content.type]}:${
                        content.hash
                    }`,
                },
            }
        );
    };

    const authMetrics = {
        login_trigger: 'discussion-content-read-more',
        community_content_key: `${content.type}-${content.hash}`,
    };

    return (
        <div className="component-UnifiedPostCard-DiscussionContent">
            {title?.length > 0 && (
                <div className="component-UnifiedPostCard-DiscussionContent__title">
                    <h1>{trueTitle}</h1>
                </div>
            )}
            {description?.length > 0 && (
                <div className="component-UnifiedPostCard-DiscussionContent__body">
                    {!showMoreButton || expandContent
                        ? trueDescription
                        : trueTruncatedDescription}
                    {showMoreButton &&
                        !expandContent &&
                        wrapAuth(
                            `discussion-content-read-more-${content.hash}`,
                            <button
                                type="button"
                                className="component-UnifiedPostCard-DiscussionContent__body__more"
                                onClick={handleExpandClick}
                            >
                                ...More
                            </button>,
                            authMetrics
                        )}
                </div>
            )}
        </div>
    );
};

DiscussionContent.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    showMoreButton: PropTypes.bool,
    characterLimit: PropTypes.number,
    handleLinkClickMetricEmit: PropTypes.func,
    // eslint-disable-next-line react/forbid-prop-types
    content: PropTypes.object,
};

DiscussionContent.defaultProps = {
    title: '',
    description: '',
    showMoreButton: false,
    characterLimit: 420,
    handleLinkClickMetricEmit: () => null,
    content: {},
};

DiscussionContent.displayName = 'DiscussionContent';

export default DiscussionContent;
